import { Injectable } from '@angular/core';
import { CompareHelper } from '@barthauer/abc/core';
import { BasysMapFrameService, RouteConfiguration, RoutingService } from '@barthauer/basys/map-frame';
import { Observable, Subject } from 'rxjs';
import { ComponentDataSource } from '../models/componentDataSource.model';
import { AppService } from '../services/app.service';
import { FrameService } from '../services/frame.service';
import { IMobileTicket } from '../viewModels/mobileData.tickets.viewModel';
import { TicketNavigationContext, TicketsDataContext, TicketStateChangeArg } from './tickets.model';
@Injectable()
export class TicketsService {
  private dataContextSubject = new Subject<TicketsDataContext>();
  private refreshNavigationContextSubject = new Subject<TicketNavigationContext>();
  private ticketStateChangedSubject = new Subject<TicketStateChangeArg>();
  private context: TicketNavigationContext;
  constructor(
    private routingService: RoutingService,

    private basysMapFrameService: BasysMapFrameService,
    private frame: FrameService
  ) {}

  raiseTicketStateChanged(data: TicketStateChangeArg) {
    this.ticketStateChangedSubject.next(data);
  }

  onTicketStateChanged(): Observable<TicketStateChangeArg> {
    return this.ticketStateChangedSubject.asObservable();
  }

  sendDataContext(dataContext: TicketsDataContext) {
    this.dataContextSubject.next(dataContext);
  }

  onDataContextSent(): Observable<TicketsDataContext> {
    return this.dataContextSubject.asObservable();
  }

  refreshNavigationContext(context: TicketNavigationContext) {
    this.context = context;
    this.refreshNavigationContextSubject.next(this.context);
  }

  onNavigationContextRefresh(): Observable<TicketNavigationContext> {
    return this.refreshNavigationContextSubject.asObservable();
  }

  navigateTo(target: string) {
    const current = this.routingService.getCurrentConfig();
    if (target !== current.designation) {
      this.frame.ensurePersistingState(() => this.internalNavigateTo(this.routingService.getCurrentConfig(), target));
    }
  }

  navigateContext(increment: number) {
    this.frame.ensurePersistingState(() => this.internalNavigateContext(increment));
  }

  private internalNavigateTo(current: RouteConfiguration, target: string) {
    this.context.sourceRoute = current;
    if (target === AppService.Route_TicketDetail) {
      this.routingService.navigateName(target).then((succ) => {
        if (succ) {
          this.refreshNavigationContext(this.context);
        }
      });
    } else {
      this.routingService.navigateName(target);
    }
  }

  private internalNavigateContext(increment: number) {
    const conf = this.routingService.getCurrentConfig();
    document.getElementById('scrollArea').scrollTop = 0;
    if (conf) {
      switch (conf.designation) {
        case AppService.Route_TicketDetail: {
          let newIndex = this.context.ticketIndex + increment;
          const dataSource = this.context.ticketDataContext.dataSource;
          if (newIndex >= 0 && newIndex <= dataSource.filteredData.length - 1) {
            if (CompareHelper.isEmptyObject(dataSource.data[newIndex])) {
              const nextIndex = this.tryGetNextTicketIndex(dataSource, newIndex, increment);
              newIndex = nextIndex > -1 ? nextIndex : newIndex;
            }
            this.context.ticketIndex = newIndex;
          }
          break;
        }
      }
    }
    this.refreshNavigationContext(this.context);
  }

  private tryGetNextTicketIndex(
    dataSource: ComponentDataSource<IMobileTicket>,
    index: number,
    increment: number
  ): number {
    if (dataSource?.filteredData.length > index && index >= 0) {
      if (CompareHelper.isEmptyObject(dataSource.data[index])) {
        if (increment === 1) {
          index++;
        } else {
          index--;
        }
        return this.tryGetNextTicketIndex(dataSource, index, increment);
      } else {
        return index;
      }
    } else {
      return -1;
    }
  }
}
